// frontend/src/services/presenceService.js
import api from "../config/api";

const presenceService = {
  getUserPresence: async (userId) => {
    try {
      const response = await api.get(`/user/presence/${userId}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching user presence:", error);
      return { status: "offline", is_online: false };
    }
  },

  checkOnlineStatus: (presence) => {
    if (!presence) return false;
    return presence.is_online || false;
  },

  sendHeartbeat: async () => {
    try {
      await api.post("/user/heartbeat");
    } catch (error) {
      console.error("Error sending heartbeat:", error);
    }
  },
};

export default presenceService;
